(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zahra-routine-journey"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zahra-routine-tabs')) {
    customElements.define(
      'zahra-routine-tabs',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
          this.classList.add('is-ready');
          this.tabs = Array.from(this.querySelectorAll('[data-routine-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-routine-panel]'));
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index));
            tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
          });
          this.select(0, false);
        }

        select(index, focus = false) {
          const update = () => {
            this.tabs.forEach((tab, tabIndex) => {
              const active = tabIndex === index;
              tab.classList.toggle('is-active', active);
              tab.setAttribute('aria-selected', String(active));
              tab.setAttribute('tabindex', active ? '0' : '-1');
            });
            this.panels.forEach((panel, panelIndex) => {
              const active = panelIndex === index;
              panel.classList.toggle('is-active', active);
              panel.hidden = !active;
            });
          };

          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (document.startViewTransition && !reducedMotion && this.dataset.initialized === 'true') {
            document.startViewTransition(update);
          } else {
            update();
          }
          this.dataset.initialized = 'true';
          if (focus) this.tabs[index].focus();
        }

        onKeydown(event, index) {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;
          if (nextIndex === index) return;
          event.preventDefault();
          this.select(nextIndex, true);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
